import api from './base'

export default {
  save ({ businessUnitId, writeOffId, items }) {
    return api().put(`company/business_units/${businessUnitId}/write_offs/${writeOffId}/articles`, items)
  },
  delete ({ businessUnitId, writeOffId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/write_offs/${writeOffId}/articles/${id}`)
  }
}
